const AuthTheme = {
  button: { backgroundColor: "#42a9d7", borderColor: "#3a90b6" },
  a: {'color': '#3a90b6'},
  input: {border: '1px solid #3a90b6'}
};
export default AuthTheme;